/** The "New booking" modal's footer — hint copy, Cancel and the submit CTA
 *  (BON-142). */
import { Loader2 } from 'lucide-react';

import type { PaymentMode } from './CreateBookingModalHelpers';

function submitLabel(mode: PaymentMode, isSubmitting: boolean): string {
  if (isSubmitting) return 'Creating…';
  return mode === 'comp' ? 'Create comp booking' : 'Reserve & email link';
}

function footerHint(hasWorkshop: boolean, mode: PaymentMode): string {
  if (!hasWorkshop) return 'Choose a workshop to continue.';
  return mode === 'comp'
    ? 'A comp booking is created immediately — no payment collected.'
    : "We never touch the customer's card — they pay securely through Stripe.";
}

export function CreateBookingModalShellFooter({
  hasWorkshop,
  mode,
  isSubmitting,
  disabled,
  onClose,
}: {
  hasWorkshop: boolean;
  mode: PaymentMode;
  isSubmitting: boolean;
  disabled: boolean;
  onClose: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-3 border-t border-stone-200 px-5 py-4 dark:border-stone-700">
      <p className="text-xs text-stone-500 dark:text-stone-400">{footerHint(hasWorkshop, mode)}</p>
      <div className="flex flex-shrink-0 items-center gap-3">
        <button
          type="button"
          onClick={onClose}
          disabled={isSubmitting}
          className="px-4 py-2 text-sm text-stone-600 hover:text-stone-800 disabled:opacity-50 dark:text-stone-400 dark:hover:text-stone-200"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={disabled}
          className="flex items-center gap-1.5 rounded-lg bg-moss-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-moss-700 disabled:opacity-50"
        >
          {isSubmitting && <Loader2 size={14} className="animate-spin" />}
          {submitLabel(mode, isSubmitting)}
        </button>
      </div>
    </div>
  );
}
